import { Capacitor } from '@capacitor/core';

/**
 * Canonical public web origin used to build shareable booking links
 * (e.g. https://app.groundaale.com).
 *
 * In a normal browser, `window.location.origin` is the real public origin, so
 * sharing works. But the iOS/Android apps are Capacitor shells that serve the
 * bundled web build from an in-app origin (https://localhost). There,
 * origin-based links resolve to nothing — so a configured public URL
 * (REACT_APP_PUBLIC_WEB_BASE_URL, inlined at build time) must be used instead.
 *
 * @returns {string} Base origin with no trailing slash, or '' if unresolvable.
 */
export function getPublicWebBaseUrl() {
  const configured = (process.env.REACT_APP_PUBLIC_WEB_BASE_URL || '').trim().replace(/\/+$/, '');
  const origin =
    typeof window !== 'undefined' && window.location ? window.location.origin : '';

  const isNative =
    !!Capacitor && typeof Capacitor.isNativePlatform === 'function' && Capacitor.isNativePlatform();

  // Inside the native shell the runtime origin (https://localhost) is not
  // shareable, so the configured public URL is required (fall back to origin
  // only if it is missing — no worse than today).
  if (isNative) return configured || origin;

  // On the web, prefer the live origin and fall back to the configured URL.
  return origin || configured;
}
